import { render, staticRenderFns } from "./LayoutLayout.vue?vue&type=template&id=45dc7743&"
import script from "./LayoutLayout.vue?vue&type=script&lang=js&"
export * from "./LayoutLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports